<div class="component-container flex flex-col">

  <div
    class="name-section-loader flex flex-row
           justify-start items-center gap-[0.8rem]"
  >
    <app-shimmer-loader
      [theme]="{
            'height': '3rem',
            'width': '3rem'
          }"
      appearance="circle"
      class="circle"
    ></app-shimmer-loader>
    <app-shimmer-loader
      [count]="1"
      [theme]="{'height': '3rem'}"
      appearance="line"
      class="line w-[30%]"
    ></app-shimmer-loader>
  </div>
  <hr class="hr line-break">

  <div class="user-details-section flex flex-col justify-center items-center">
    <div
      class="section-heading-loader
               flex flex-row justify-start
               items-center w-full"
    >
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '3rem'}"
        appearance="line"
        class="line w-[35%] mb-[2.4rem]"
      ></app-shimmer-loader>
    </div>

    <div class="user-details-loader w-10/12 flex flex-col justify-center items-center">
      <div class="display-section flex flex-col justify-center items-center">
        <div
          class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
        >
          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>
          </div>

          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>
        </div>
        <div
          class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
        >
          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>

          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>
        </div>
        <div
          class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
        >
          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>

          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>
        </div>
        <div
          class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
        >
          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>

          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>
        </div>
        <div
          class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
        >
          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>

          <div *ngIf="userDetails?.role === roles?.participant"
               class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>
        </div>
        <div
          *ngIf="userDetails?.role === roles?.participant"
          class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
        >
          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="label-loader w-2/5"
            ></app-shimmer-loader>

            <app-shimmer-loader
              [count]="1"
              [theme]="{'height': '3rem'}"
              appearance="line"
              class="value-loader w-3/5"
            ></app-shimmer-loader>

          </div>
          <div
            class="sub-row w-full md:w-[50%] md:min-w-[50%] flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]">
          </div>
        </div>
      </div>
      <div class="action-section flex flex-row
              justify-end items-center md:mr-[12rem] mr-[0]">
        <app-shimmer-loader
          [count]="1"
          [theme]="{'height': '3rem'}"
          appearance="line"
          class="edit-button w-[7.5rem]"
        ></app-shimmer-loader>

      </div>
    </div>

  </div>
</div>
